import React from 'react';
import { useMultiSelect } from '../hooks/UseMultiSelect';
export var DropdownHeader = function () {
    var _a = useMultiSelect(), t = _a.t, value = _a.value, options = _a.options, valueRenderer = _a.valueRenderer;
    var noneSelected = value.length === 0;
    var allSelected = value.length === options.length;
    var customText = valueRenderer && valueRenderer(value, options);
    var getSelectedText = function () { return value.map(function (s) { return s.label; }).join(', '); };
    return noneSelected ? (React.createElement("span", { className: "gray" }, customText || t('selectSomeItems'))) : (React.createElement("span", null, customText ||
        (allSelected ? t('allItemsAreSelected') : getSelectedText())));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/multi-select/DropdownHeader.tsx
// module id = 1190
// module chunks = 0